import { hasAnalyticsConsent } from "./consent";

const KEY = "eap-visitor-id";

/**
 * Pseudonymous, first-party visitor marker used to connect a download
 * with a later enquiry or video call booking. No personal data, no IP,
 * stays in localStorage of this browser only (DSGVO: pseudonymised).
 *
 * Returns null unless the visitor consented to the analytics category —
 * without consent no marker is created or stored.
 */
export const getVisitorId = (): string | null => {
  if (!hasAnalyticsConsent()) return null;
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
    const id =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, id);
    return id;
  } catch {
    return null;
  }
};

/** Existing marker without creating one (used for attribution lookups). */
export const peekVisitorId = (): string | null => {
  if (!hasAnalyticsConsent()) return null;
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};
